import i18next from 'i18next';
import { DOC_TYPE_AADE_CODE, DOC_TYPE_AADE_CODE_VALUES } from '../../interfaces/documentType.interface';
import { InvoiceInterface, TaxWithhold } from '../../interfaces/invoice.interface';

export const isDocTypeCodeValidForTaxWithhold = (docTypeCode: DOC_TYPE_AADE_CODE_VALUES) => {
  const allowedDocTypes = [
    DOC_TYPE_AADE_CODE.PRO_FORMA_INVOICE,
    DOC_TYPE_AADE_CODE.INVOICE_SERVICES,
    DOC_TYPE_AADE_CODE.INVOICE_RETURN_RELATED,
    DOC_TYPE_AADE_CODE.INVOICE_RETURN_UNRELATED,
  ] as DOC_TYPE_AADE_CODE_VALUES[];
  return allowedDocTypes.includes(docTypeCode);
};

export const shouldShowTaxWithhold = (doc: InvoiceInterface) => {
  if (doc.taxWithholdPercentage && isDocTypeCodeValidForTaxWithhold(doc.documentType?.aadeCode)) return true;

  return false;
};

export const defaultTaxWithhold = (data: TaxWithhold[]) => {
  return data?.map((entity) => {
    return {
      label: i18next.t(`TAX_WITHHOLD.${entity?.name}`),
      value: entity?.id,
      object: entity,
    };
  });
};
